import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { RetornaDadosRequest } from "../helpers/retorna-dados-request";
import { IProductByResponse, IProductResponse } from "../interfaces/product.interface";
import { IResponseData, IResponseListData } from "../interfaces/response-data.interface";
@Injectable({
	providedIn: "root"
})
export class ProductService {
	constructor(
		private http: HttpClient,
		private retornoStatus: RetornaDadosRequest
	) {}

	getAll(): Observable<IResponseListData<IProductResponse>> {
		return this.http.get<IResponseListData<IProductResponse>>(`${environment.urlApi}/product/getproduct`);
	}

	getById(id: number): Observable<IResponseData<IProductByResponse>> {
		return this.http.get<IResponseData<IProductByResponse>>(`${environment.urlApi}/product/getproduct?id=${id}`);
	}

	GetPropostaSetorByProduto(produtoId: number, tipoPropostaId: number): Observable<any> {
		let params = new HttpParams();
		params = params.append("idProduto", produtoId.toString());
		params = params.append("idTipoProposta", tipoPropostaId.toString());
		return this.http.get<any>(`${environment.urlApi}/PropostaSector/GetPropostaSetorByProduto`, { params });
	}
}
